const { ccclass, property } = cc._decorator;
import ViewBase from "../../../framework/core/mvvm/view_base";
import LanguageManager from "../../../manager/language_manager";

@ccclass
export default abstract class ClubPromotionView extends ViewBase {
    @property(cc.Label)
    myId:cc.Label = null

    @property(cc.Label)
    myTudiCount:cc.Label = null

    @property(cc.Label)
    shifuId:cc.Label = null

    @property(cc.Label)
    xueyuanId:cc.Label = null

    @property(cc.Label)
    xueyuanCount:cc.Label = null

    @property(cc.Label)
    tudiGongxian:cc.Label = null

    @property(cc.Label)
    gerengShouru:cc.Label = null

    @property(cc.Label)
    tuanduiGongxian:cc.Label = null

    @property(cc.Label)
    tuanduiShouru:cc.Label = null

    @property(cc.Label)
    zonShouru:cc.Label = null

    @property(cc.Label)
    canShouru:cc.Label = null

    @property(cc.Node)
    bankTipsNode:cc.Node = null


    //显示推广的基本信息
    showBaseInfo(baseData, roleData){
        this.myId.string            = roleData.id.toString()
        this.myTudiCount.string     = baseData.childNum.toString()
        this.shifuId.string         = roleData.parentId.toString()
        this.xueyuanId.string       = "-"
        this.xueyuanCount.string    = "-"
        this.tudiGongxian.string    = baseData.person
        this.gerengShouru.string    = baseData.personIncome 
        this.tuanduiGongxian.string = baseData.team
        this.tuanduiShouru.string   = baseData.teamIncome 
        this.zonShouru.string       = baseData.totalIncome 
        this.canShouru.string       = baseData.advance 
    }


}